import { render, staticRenderFns } from "./AdvCartProductCustomizationEditor.vue?vue&type=template&id=16ddb28d&scoped=true"
import script from "./AdvCartProductCustomizationEditor.vue?vue&type=script&lang=js"
export * from "./AdvCartProductCustomizationEditor.vue?vue&type=script&lang=js"
import style0 from "./AdvCartProductCustomizationEditor.vue?vue&type=style&index=0&id=16ddb28d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ddb28d",
  null
  
)

export default component.exports